/* @flow */

import * as React from 'react';

import AccountDetailsPage from 'views/AccountDetailsPage/AccountDetailsPage';
import { SpecificUserDetail } from 'views/AccountDetailsPage';
import AccountsReportView from 'tables/AccountsReportView/AccountsReportView';

import CompanyDetailsPage from 'views/LocationDetails/views/CompanyDetailsPage';
import CountryDetailsPage from 'views/LocationDetails/views/CountryDetailsPage';
import LocationDetailsPage from 'views/LocationDetails/views/LocationDetailsPage';

import { allRoles } from 'permissions/general';

import {
  createNewLocation,
  createInviteUser,
  createNewAccount,
  updateEditAccount,
} from 'permissions/account';

import AccountForm from '../forms/AccountForm/AccountForm';

import LocationForm from '../forms/LocationForm/LocationForm';

import AccountsInviteUserForm from '../forms/AccountsInviteUserForm/AccountsInviteUserForm';

import type { TypeComponent } from './types';

const accountRoutes: Array<*> = [
  {
    path: '/accounts',
    title: 'general:document_titles.accounts.title',
    component: AccountsReportView,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/accounts/create',
    title: 'general:document_titles.accounts.create',
    component(): React.Element<*> {
      return <AccountForm mode="create" />;
    },
    exact: true,
    permissions: createNewAccount,
  },
  {
    path: '/accounts/edit',
    title: 'general:document_titles.accounts.edit',
    component({ location }: Object): React.Element<*> {
      return <AccountForm mode="edit" accountData={location.state ? location.state : {}} />;
    },
    exact: true,
    permissions: updateEditAccount,
  },
  {
    path: '/accounts/:id',
    title: 'general:document_titles.accounts.detail',
    title_keys: ['details.details.name', 'details.details.account_no'],
    component: AccountDetailsPage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/accounts/:id/:actionType',
    title: 'general:document_titles.accounts.action_type',
    title_keys: ['details.details.name', 'details.details.account_no', 'currentActionDrawer'],
    component: AccountDetailsPage,
    exact: true,
    permissions: allRoles,
    state: { tab: 0 },
  },
  {
    path: '/accounts/:id/user/invite',
    title: 'general:document_titles.accounts.invite',
    component: function FormInviteUser(props: any): TypeComponent {
      return <AccountsInviteUserForm params={props.match.params} />;
    },
    exact: true,
    permissions: createInviteUser,
  },
  {
    path: '/accounts/:id/contract/:countract_id',
    title: 'general:document_titles.accounts.title',
    component: AccountDetailsPage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/accounts/:id/user/:userId',
    title: 'general:document_titles.accounts.manage_user',
    title_keys: ['details.details.name', 'specificUser.full_name'],
    component: function SpecificUser(props: any): TypeComponent {
      return <SpecificUserDetail params={props.match.params} />;
    },
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/accounts/:id/user/invite/:userRole',
    title: 'general:document_titles.accounts.invite',
    component: function FormInviteUser(props: any): TypeComponent {
      return <AccountsInviteUserForm params={props.match.params} />;
    },
    exact: true,
    permissions: createInviteUser,
  },
  {
    path: '/accounts/:id/location/create',
    title: 'general:document_titles.accounts.create_location',
    component: function FormCreateNewLocation(props: any): TypeComponent {
      return <LocationForm mode="create" params={props.match.params} />;
    },
    exact: true,
    permissions: createNewLocation,
  },
  {
    path: '/accounts/:id/location/:locationId/edit',
    title: 'general:document_titles.accounts.edit_location',
    title_keys: ['details.details.name'],
    component({ location }: Object): React.Element<*> {
      return <LocationForm mode="edit" itemData={location.state ? location.state : {}} />;
    },
    exact: true,
    permissions: createNewLocation,
  },
  {
    path: '/accounts/:id/location/:companyId',
    title: 'general:document_titles.accounts.manage_location',
    title_keys: ['details.details.name', 'companyDetails.company_name'],
    component: CompanyDetailsPage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/accounts/:id/location/:companyId/:countryId',
    title: 'general:document_titles.accounts.manage_country',
    title_keys: ['details.details.name', 'countryDetails.country_name'],
    component: CountryDetailsPage,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/accounts/:id/location/:companyId/:countryId/:locationId',
    title: 'general:document_titles.accounts.manage_site',
    title_keys: ['details.details.name', 'locationDetails.location_name'],
    component: LocationDetailsPage,
    exact: true,
    permissions: allRoles,
  },
];

export default accountRoutes.map(item => ({
  ...item,
  store: ['accountStore', 'actionDrawerStore'],
}));
